<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div>
          <ul class="nav nav-pills mb-4" role="tablist" id="v-pills-tab">
            <li class="nav-item mr-2">
              <button
                class="btn btn-outline-primary nav-link"
                v-bind:class="{ active: page == 1 }"
                v-on:click="changePage(1)"
              >
                Groups, Subjects and Units
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 2 }"
                v-on:click="changePage(2)"
              >
                Permissions
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 3 }"
                v-on:click="changePage(3)"
              >
                Scores and Templates
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 4 }"
                v-on:click="changePage(4)"
              >
                Behavior Trackers
              </button>
            </li>
          </ul>
          <Hierarchy
            v-if="page == 1"
            @go-to-scores="changePage(3)"
            @go-to-permissions="changePage(2)"
          />
          <Permissions
            v-if="page == 2"
            @go-to-behavior="changePage(4)"
            @go-to-hierarchy="changePage(1)"
          />
          <ScoreTemplates
            v-if="page == 3"
            v-bind:TemplateInputTypes="templateInputTypes"
          />
          <BehaviorTrackers
            v-if="page == 4"
            v-bind:TemplateInputTypes="templateInputTypes"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hierarchy from "@/components/Help/Hierarchy.vue";
import Permissions from "@/components/Help/Permissions.vue";
import ScoreTemplates from "@/components/Help/ScoreTemplates.vue";
import BehaviorTrackers from "@/components/Help/BehaviorTrackers.vue";

export default {
  components: {
    Hierarchy,
    Permissions,
    ScoreTemplates,
    BehaviorTrackers
  },
  data() {
    return {
      page: 1,
      templateInputTypes: []
    };
  },
  async mounted() {
    this.templateInputTypes = await this.$getScoreTemplateInputTypes();
  },
  methods: {
    changePage(num) {
      this.page = num;
    }
  }
};
</script>
